import React from 'react';
import ObjectRegisteryTable from "../../dashboard/apiTables/ObjectRegisteryTable";

const ExternalTable = () => {
    return (
        <div style={{marginTop: 50, marginBottom: 150, marginRight: "3%", marginLeft: "3%"}}>
            <ObjectRegisteryTable/>
        </div>
    );
};

export default ExternalTable;
